import { produce } from 'immer';

import { LoadInternalProducts } from '../../../actions/products/internal/loadInternalProducts';
import { ProductsPageStates, ProductsState } from '../../../typings/products';

export function loadInternalProducts(state: ProductsState, action: LoadInternalProducts): ProductsState {
    return produce(state, draft => {
        draft.pageStatus = ProductsPageStates.LOADING;
    });
}
